<template>
  <div class="mydevice-bd">
    <div class="product-wrap">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('crm_partner-customer.jtkhmc')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          ref="tb1"
          v-loading="isLoading"
          tableCode="crm_large_customer"
          :data="groupCustomerList"
          height="100%"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
           @column="setColumn"
          :filterArr="['action']"
          :slots="['partnerName']"
        >
        <template v-slot:partnerName="scope">
          <div class="cell-link" @click="jump('/customer/groupCustomer/detail',{groupCustomerId: scope.row.partnerId, bizType: scope.row.partnerType, parentPath: $route.fullPath})">{{ scope.row.partnerName }}</div>
        </template>
      </custom-table>
      </div>
      <div class="table-page">
        <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
      </div>
    </div>
    <!-- 商品详情弹窗 -->
    <!-- <product-detail-dialog v-model="dialogVisible" :productId="productId" :model="dialogModel"></product-detail-dialog> -->
    <!-- <waitdevice></waitdevice> -->
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import waitdevice from './waitdevice.vue';

export default {
  props: ['partnerOrgId', 'partnerId', 'partnerType'],
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerType: '',
        partnerId: '',
        businessLicense: ''
      },

      // formSearch: {
      //   search: '',
      //   orderType: '',
      //   orderBy: '',
      //   pageSize: 50,
      //   pageNum: 1,
      //   bizType: 'factory', // 总部service
      //   partnerId: '',
      //   businessLicense: ''
      // },
      groupCustomerList: [],
      totalRows: null
    };
  },
  mounted() {
    this.formSearch.orgId = this.partnerOrgId;
    // 租赁方ID
    this.formSearch.partnerId = this.partnerId;
    // this.formSearch.partnerType = this.partnerType;
    this.formSearch.childOrgType = this.partnerType;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getRenter();
  },
  methods: {
    // 获取我的设备列表
    getRenter: function () {
      this.isLoading = true;
      this.$getJSON(apis.partnerPage, this.formSearch).then((res) => {
        this.isLoading = false;
        const list = res.data.list;
        this.groupCustomerList = list;
        this.totalRows = res.data.total;
      });
    },

    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRenter();
    },

  }
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 220px;
    display: flex;
    .g2-p1 {
      width: 500px;
      height: 220px;
    }
    .g2-p2 {
      width: 460px;
      height: 200px;
      .g2-legend {
        height: 120px !important;
        width: 800px !important;
        max-width: 800px !important;
      }
      .g2-legend-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100%;
      }
      .g2-legend-list-item {
        width: 120px;
      }
    }
  }
  .product-wrap {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
